<template>
  <Dialog v-model:visible="showAddModal" class="w-full lg:w-3/4 bg-white shadow rounded-xl" :modal="true" style="position:relative">
    <loading :active="showSelectPostDialogMyside"
            :can-cancel="true"
            :on-cancel="onCancel"
            :is-full-page="false"
            :color="'#fff'"
            :background-color="'#000'"
            :opacity="'0.8'"
            :loader=" dots">
    </loading>
    <template #header>
      <div class="w-full text-gray-900 font-semibold">
        {{lang['components']['Event']['EditMaterial']['title']}}
      </div>
    </template>
    <div class="flex flex-wrap mb-2">
      <div class="w-full flex-1 bg-white rounded-xl space-y-6 p-2 lg:p-6">
        <div>
          <span class="text-red-500">*</span>
          <span class="text-grap-700 align-middle">{{lang['components']['Event']['EditMaterial']['block_name']}}</span>
          <i
            class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
            v-tooltip="`${lang['components']['Event']['EditMaterial']['block_info']}`"
          ></i>
        </div>
        <!-- <div class="flex-1 space-y-4 tab"> -->
        <div class="flex-1 space-y-4 tab overflow-hidden">
          <div class="flex scrollbar-x">
            <div
              class="flex px-4 py-2 cursor-pointer bg-gray-100 whitespace-nowrap"
              :class="{
                'bg-yellow-300 text-blue-700': currentTab === index
              }"
              v-for="(item, index) in items"
              :key="index"
              @click="adContent(index)"
            >
              <p v-if="!item.isEdit" class="flex-none truncate w-20">
                {{ item.title ? item.title : lang['components']['Event']['EditMaterial']['ad_name'] }}
              </p>

              <input
                v-if="item.isEdit"
                :disabled="editPageType && returnCampaignObjectiveData != 'LEAD_GENERATION'"
                v-model="item.title"
                class="p-inputtext p-component py-0 w-40 underline-box border-show bg-transparent"
                type="text"
                :placeholder="lang['components']['Event']['EditMaterial']['ad_name_placeholder']"
                v-on:keyup="isChangeData()"
              />
              <i
                v-if="currentTab === index"
                @click="item.isEdit = !item.isEdit"
                class="pi pi-pencil mt-2 ml-2"
                style="fontSize: 0.8rem"
              ></i>
            </div>
            <div class="px-4 py-2 cursor-pointer" @click="addItem()">
              <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
            </div>
          </div>
          <!-- <div class="flex text-gray-500">
            <div
              class="px-4 py-2 cursor-pointer bg-gray-100"
              :class="{
                'bg-yellow-300': currentTab === index
              }"
              v-for="(item, index) in items"
              :key="index"
              @click="adContent(index)"
            >
              <span v-if="!item.isEdit">{{ item.title }}</span>

              <input
                v-if="item.isEdit"
                v-model="item.title"
                class="p-inputtext p-component py-0 w-40 underline-box border-show bg-transparent"
                type="text"
                placeholder="廣告"
              />
              <i
                v-if="currentTab === index"
                @click="item.isEdit = !item.isEdit"
                class="pi pi-pencil ml-2"
                style="fontSize: 0.8rem"
              ></i>
            </div>
            <div class="px-4 py-2 cursor-pointer" @click="addItem()">
              <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
            </div>
          </div> -->
          <TabView v-model:activeIndex="currentTab">
            <template v-for="(item, index) in items" :key="index">
              <TabPanel>
                <template #hearder>
                  <div></div>
                </template>
                <div class="space-y-2 pb-8 my-4">
                  <div>
                    <!-- <span class="text-red-500">*</span> -->
                    <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['EditMaterial']['format_info']}}</span>
                    <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'格式'"></i> -->
                  </div>
                  <div class="flex flex-wrap gap-2">
                    <button
                      class="text-sm border border-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1"
                      :class="[
                        item.type == 1 ? 'bg-blue-700' : 'bg-white',
                        item.type == 1 ? 'text-white' : 'text-blue-700'
                      ]"
                      @click="changeType(index, 1)"
                    >
                      <i class="pi pi-image mr-3" style="fontSize: 0.8rem"></i>
                      <span v-if="this.goalsObjectiveData != 'VIDEO_VIEWS'">{{lang['components']['Event']['EditMaterial']['single_material']}}</span>
                      <span v-if="this.goalsObjectiveData == 'VIDEO_VIEWS'">{{lang['components']['Event']['EditMaterial']['single_video_material']}}</span>
                    </button>
                    <button
                      v-if="this.goalsObjectiveData != 'VIDEO_VIEWS' && this.goalsObjectiveData != 'POST_ENGAGEMENT'"
                      class="text-sm border border-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1"
                      :class="[
                        item.type == 2 ? 'bg-blue-700' : 'bg-white',
                        item.type == 2 ? 'text-white' : 'text-blue-700'
                      ]"
                      @click="changeType(index, 2)"
                    >
                      <i class="pi pi-images" style="fontSize: 0.8rem"></i>
                      {{lang['components']['Event']['EditMaterial']['carousel_material']}}
                    </button>
                    <button
                      class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 lg:ml-auto"
                      @click="removeAd(index)"
                    >
                      {{lang['components']['Event']['EditMaterial']['delete_material']}}
                    </button>
                  </div>
                  <hr />
                </div>
                <!-- Enhancements 開關 -->
                <div class="flex items-center space-x-6 my-4">
                  <label class="inline-flex items-center">
                    <InputSwitch v-model="item.visual_touchup" :disabled="editPageType" @change="isChangeData()" />
                    <span class="ml-2 text-gray-700 text-sm">{{lang['components']['Event']['EditMaterial']['visual_touchup']}}</span>
                    <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                       v-tooltip="`${lang['components']['Event']['EditMaterial']['visual_touchup_info']}`"></i>
                  </label>
                  <label class="inline-flex items-center">
                    <InputSwitch v-model="item.add_animation" :disabled="editPageType" @change="isChangeData()" />
                    <span class="ml-2 text-gray-700 text-sm">{{lang['components']['Event']['EditMaterial']['add_animation']}}</span>
                    <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                       v-tooltip="`${lang['components']['Event']['EditMaterial']['add_animation_info']}`"></i>
                  </label>
                  <label class="inline-flex items-center">
                    <InputSwitch v-model="item.flexible_media" :disabled="editPageType" @change="isChangeData()" />
                    <span class="ml-2 text-gray-700 text-sm">{{lang['components']['Event']['EditMaterial']['flexible_media']}}</span>
                    <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
                       v-tooltip="`${lang['components']['Event']['EditMaterial']['flexible_media_info']}`"></i>
                  </label>
                </div>
                <div class="space-y-2 pb-8 my-4" v-if="item.type == 1" style="position:relative">
                  <loading :active="!showMaterialSingle"
                          :can-cancel="true"
                          :on-cancel="onCancel"
                          :is-full-page="false"
                          :color="'#fff'"
                          :background-color="'#000'"
                          :opacity="'0.8'"
                          :loader=" dots">
                  </loading>
                  <div>
                    <!-- <span class="text-red-500">*</span> -->
                    <span class="text-grap-700 align-middle text-sm"
                      >{{lang['components']['Event']['EditMaterial']['material_setting']}}</span
                    >
                    <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'格式'"></i> -->
                  </div>
                  <div>
                    <button
                      v-on:click="getImageVideoList(item.type, 0)"
                      class="text-sm border border-blue-700 bg-blue-700 text-white rounded-md px-4 py-1"
                      v-if="item.materialSingle.length == 0"
                    >
                      <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
                      {{lang['components']['Event']['EditMaterial']['add_material']}}
                    </button>
                    <div
                      v-for="(itemSingle, i) in item.materialSingle"
                      :key="i"
                      class="flex justify-between bg-gray-100 rounded-xl border overflow-hidden p-1 w-full hover:border-grap-400 mt-4"
                    >
                      <div class="flex p-1">
                        <div class="md:flex-shrink-0">
                          <img
                            class="h-24 w-24 rounded-xl object-cover"
                            :src="itemSingle.imgSrc"
                          />
                        </div>
                        <div class="mx-2 lg:mx-8">
                          <p class="text-gray-800 text-sm">
                            {{ itemSingle.fileName ? itemSingle.fileName : "" }}
                            <template v-for="(_tmp_object_spec, obj_index) in itemSingle.object_spec">
                              <template v-if="obj_index == 'type' && _tmp_object_spec == 'image'">
                                {{lang['components']['Event']['EditMaterial']['material_type_image']}}
                              </template>
                              <template v-if="obj_index == 'type' && _tmp_object_spec == 'video'">
                                {{lang['components']['Event']['EditMaterial']['material_type_video']}}
                              </template>
                            </template>
                          </p>
                          <p class="text-gray-500 text-sm">{{ itemSingle.size }}</p>
                          <button
                            class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 mt-4"
                            v-on:click="getImageVideoList(item.type, 0)"
                          >
                            {{lang['components']['Event']['EditMaterial']['change_material']}}
                          </button>
                        </div>
                      </div>
                      <!-- <i class="pi pi-times cursor-pointer text-right m-2"></i> -->
                    </div>
                  </div>
                </div>
                <div class="space-y-2 pb-8 my-4" v-if="item.type == 2">
                  <div>
                    <!-- <span class="text-red-500">*</span> -->
                    <span class="text-grap-700 align-middle text-sm"
                      >{{lang['components']['Event']['EditMaterial']['carousel_card']}}</span
                    >
                    <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'格式'"></i> -->
                  </div>
                  <div>
                    <draggable
                      v-if="item.materials.length"
                      v-model="item.materials"
                      :disabled="isEdit"
                      @start="drag = true"
                      @end="drag = false"
                      item-key="id"
                    >
                      <template #item="{ element }" >
                        <div
                          class="bg-white bg-blue-100 rounded-xl border overflow-hidden p-4 w-full hover:border-grap-400 mt-4 space-y-2"
                        >
                          <div class="flex justify-between ">
                            <div class="flex p-1">
                              <div class="my-auto -ml-2">
                                <i
                                  class="pi pi-ellipsis-v"
                                  style="fontSize: 1.3rem"
                                ></i>
                                <i
                                  class="pi pi-ellipsis-v -ml-2"
                                  style="fontSize: 1.3rem"
                                ></i>
                              </div>
                              <div class="md:flex-shrink-0">
                                <img
                                  class="h-24 w-24 rounded-xl object-cover cursor-pointer"
                                  v-if="element.imgSrc"
                                  :src="element.imgSrc"
                                  @click="element.isEdit = !element.isEdit"
                                />
                                <div
                                  v-else
                                  class="h-24 w-24 rounded-xl border cursor-pointer border-gray-400 text-center"
                                  @click="element.isEdit = !element.isEdit"
                                >
                                  <i
                                    class="pi pi-plus my-7"
                                    style="fontSize: 2rem"
                                  ></i>
                                </div>
                              </div>
                              <div class="mx-2 lg:mx-8 my-auto">
                                <p class="text-gray-800 text-sm">
                                  <template v-if="element.object_spec.title != ''">
                                    {{element.object_spec.title}}
                                  </template>
                                  <template v-if="element.object_spec.name != ''">
                                    {{element.object_spec.name}}
                                  </template>
                                  <template v-if="element.object_spec.type == 'image'">
                                    {{lang['components']['Event']['EditMaterial']['material_type_image']}}
                                  </template>
                                  <template v-if="element.object_spec.type == 'video'">
                                    {{lang['components']['Event']['EditMaterial']['material_type_video']}}
                                  </template>
                                </p>
                                <p class="text-gray-500 text-sm">
                                  <span v-if="element.title != ''" class="truncate w-20">
                                    {{ element.title }}
                                  </span>
                                  <span v-if="element.title == ''" class="w-20">
                                    {{lang['components']['Event']['EditMaterial']['not_title']}}
                                  </span>
                                   -
                                   <span v-if="element.description != ''" class="truncate w-20">
                                    {{ element.description }}
                                  </span>
                                  <span v-if="element.description == ''" class="w-20">
                                    {{lang['components']['Event']['EditMaterial']['not_description']}}
                                  </span>
                                   -
                                   <span v-if="element.website != ''" class="truncate w-20">
                                    {{ element.website }}
                                  </span>
                                  <span v-if="element.website == ''" class="w-20">
                                    {{lang['components']['Event']['EditMaterial']['not_website']}}
                                  </span>
                                </p>
                              </div>
                            </div>
                            <div class="flex flex-col">
                              <i
                                v-if="item.materials.length > 2"
                                class="pi pi-times cursor-pointer text-right m-2"
                                @click="removeItem(currentTab, element.index)"
                              ></i>
                              <i
                                class="pi cursor-pointer my-auto text-right mx-2 text-blue-400"
                                :class="[element.isEdit ? 'pi-angle-up' : 'pi-pencil']"
                                style="fontSize: 1.2rem"
                                @click="element.isEdit = !element.isEdit"
                              ></i>
                            </div>
                          </div>
                          <div
                            class="w-full flex-1 bg-white rounded-xl space-y-6 p-6 transition duration-500"
                            v-show="element.isEdit"
                            style="position:relative"
                          >
                          <loading :active="!showMaterial"
                                  :can-cancel="true"
                                  :on-cancel="onCancel"
                                  :is-full-page="false"
                                  :color="'#fff'"
                                  :background-color="'#000'"
                                  :opacity="'0.8'"
                                  :loader=" dots">
                          </loading>
                            <div
                              class="flex justify-between bg-gray-100 rounded-xl border overflow-hidden p-1 w-full hover:border-grap-400 mt-4"
                              v-if="element.imgSrc"
                            >
                              <div class="flex p-1">
                                <div class="md:flex-shrink-0">
                                  <img
                                    class="h-24 w-24 rounded-xl object-cover"
                                    :src="element.imgSrc"
                                  />
                                </div>
                                <div class="mx-2 lg:mx-8">
                                  <p class="text-gray-800 text-sm">
                                    <template v-if="element.object_spec.title != ''">
                                      {{element.object_spec.title}}
                                    </template>
                                    <template v-if="element.object_spec.name != ''">
                                      {{element.object_spec.name}}
                                    </template>
                                    <template v-if="element.object_spec.type == 'image'">
                                      {{lang['components']['Event']['EditMaterial']['material_type_image']}}
                                    </template>
                                    <template v-if="element.object_spec.type == 'video'">
                                      {{lang['components']['Event']['EditMaterial']['material_type_video']}}
                                    </template>
                                  </p>
                                  <p class="text-gray-500 text-sm">{{element.object_spec.width}}*{{element.object_spec.height}}</p>
                                  <button
                                    class="text-sm border border-blue-400 bg-blue-400 text-white rounded-md px-4 py-1 mt-4"
                                    v-on:click="getImageVideoList(item.type, element.index)"
                                  >
                                    {{lang['components']['Event']['EditMaterial']['change_material']}}
                                  </button>
                                </div>
                              </div>
                              <i
                                v-if="false"
                                class="pi pi-times cursor-pointer text-right m-2"
                                @click="removeItem(currentTab, element.index)"
                              ></i>
                            </div>
                            <button
                              v-on:click="getImageVideoList(item.type, element.index)"
                              class="text-sm border border-blue-700 bg-blue-700 text-white rounded-md px-4 py-1"
                              v-else
                            >
                              <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
                              {{lang['components']['Event']['EditMaterial']['add_material']}}
                            </button>
                            <div v-if="optimizationAction != 'PAGE_LIKES'">
                              <span class="text-grap-700 align-middle text-sm"
                                >{{lang['components']['Event']['EditMaterial']['material_title']}}</span
                              >
                              <input
                                class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                                type="text"
                                :placeholder="lang['components']['Event']['EditMaterial']['material_title_placeholder']"
                                :disabled="editPageType"
                                v-model="element.title"
                                v-on:keyup="isChangeData()"
                                v-on:focus="lock()"
                                v-on:blur="unlock()"
                              />
                            </div>
                            <div v-if="optimizationAction != 'PAGE_LIKES'">
                              <span class="text-grap-700 align-middle text-sm"
                                >{{lang['components']['Event']['EditMaterial']['material_description']}}</span
                              >
                              <input
                                class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                                type="text"
                                :placeholder="lang['components']['Event']['EditMaterial']['material_description_placeholder']"
                                :disabled="editPageType"
                                v-model="element.description"
                                v-on:keyup="isChangeData()"
                                v-on:focus="lock()"
                                v-on:blur="unlock()"
                              />
                            </div>
                            <div v-if="optimizationAction != 'PAGE_LIKES' && goalsObjectiveData != 'LEAD_GENERATION' && goalsObjectiveData != 'MESSAGES'">
                              <span class="text-grap-700 align-middle text-sm"
                                >{{lang['components']['Event']['EditMaterial']['material_website']}}</span
                              >
                              <input
                                class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                                type="text"
                                :placeholder="lang['components']['Event']['EditMaterial']['material_website_placeholder']"
                                :disabled="editPageType"
                                v-model="element.website"
                                v-on:keyup="isChangeData()"
                                v-on:focus="lock()"
                                v-on:blur="unlock()"
                              />
                            </div>
                          </div>
                        </div>
                      </template>
                    </draggable>

                    <!-- <div
                      class="bg-white bg-blue-100 rounded-xl border overflow-hidden p-4 w-full hover:border-grap-400 mt-4 space-y-2"
                      v-for="(material, materIndex) in item.materials"
                      :key="materIndex"
                    >
                      <div class="flex justify-between ">
                        <div class="flex p-1">
                          <div class="my-auto -ml-2">
                            <i
                              class="pi pi-ellipsis-v"
                              style="fontSize: 1.3rem"
                            ></i>
                            <i
                              class="pi pi-ellipsis-v -ml-2"
                              style="fontSize: 1.3rem"
                            ></i>
                          </div>
                          <div class="md:flex-shrink-0">
                            <img
                              class="h-24 w-24 rounded-xl object-cover cursor-pointer"
                              v-if="material.imgSrc"
                              :src="material.imgSrc"
                            />
                            <div
                              v-else
                              class="h-24 w-24 rounded-xl border cursor-pointer border-gray-400 text-center"
                            >
                              <i
                                class="pi pi-plus my-7"
                                style="fontSize: 2rem"
                              ></i>
                            </div>
                          </div>
                          <div class="mx-2 lg:mx-8 my-auto">
                            <p class="text-gray-800 text-sm">Untitled</p>
                            <p class="text-gray-500 text-sm">
                              標題：{{ material.title }}
                            </p>
                          </div>
                        </div>
                        <i
                          class="pi cursor-pointer my-auto text-right mx-2"
                          :class="[material.isEdit ? 'pi-angle-up' : 'pi-pencil']"
                          style="fontSize: 1.2rem"
                          @click="material.isEdit = !material.isEdit"
                        ></i>
                      </div>
                      <div
                        class="w-full flex-1 bg-white rounded-xl space-y-6 p-6 transition duration-500"
                        v-show="material.isEdit"
                      >
                        <div
                          class="flex justify-between bg-gray-100 rounded-xl border overflow-hidden p-1 w-full hover:border-grap-400 mt-4"
                          v-if="material.imgSrc"
                        >
                          <div class="flex p-1">
                            <div class="md:flex-shrink-0">
                              <img
                                class="h-24 w-24 rounded-xl object-cover"
                                :src="material.imgSrc"
                              />
                            </div>
                            <div class="mx-2 lg:mx-8">
                              <p class="text-gray-800 text-sm">Untitled</p>
                              <p class="text-gray-500 text-sm">800*800</p>
                              <button
                                class="text-sm border border-blue-700 bg-blue-700 text-white rounded-md px-4 py-1 mt-4"
                                v-on:click="getImageVideoList(item.type, materIndex)"
                              >
                                更換素材
                              </button>
                            </div>
                          </div>
                          <i
                            class="pi pi-times cursor-pointer text-right m-2"
                          ></i>
                        </div>
                        <button
                          v-on:click="getImageVideoList(item.type, materIndex)"
                          class="text-sm border border-blue-700 bg-blue-700 text-white rounded-md px-4 py-1"
                          v-else
                        >
                          <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
                          新增影音素材
                        </button>
                        <div>
                          <span class="text-grap-700 align-middle text-sm"
                            >標題</span
                          >
                          <input
                            class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                            type="text"
                            placeholder="請輸入標題"
                            v-model="material.title"
                          />
                        </div>
                        <div>
                          <span class="text-grap-700 align-middle text-sm"
                            >說明</span
                          >
                          <input
                            class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                            type="text"
                            placeholder="請輸入說明"
                            v-model="material.description"
                          />
                        </div>
                        <div>
                          <span class="text-grap-700 align-middle text-sm"
                            >網站網址</span
                          >
                          <input
                            class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                            type="text"
                            placeholder="請輸入網站網址"
                            v-model="material.website"
                          />
                        </div>
                      </div>
                    </div> -->
                    <button
                      class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 mt-4"
                      @click="addMaterials(index)"
                    >
                      {{lang['components']['Event']['EditMaterial']['add_carousel_card']}}
                    </button>
                    <label class="inline-flex items-center mt-3 w-full" v-if="item.type == 2">
                      <input type="checkbox" :disabled="editPageType" v-model="item.multi_share_optimized" v-on:change="isChangeData()"/>
                      <span class="ml-2 text-gray-700 text-sm"
                        >{{lang['components']['Event']['EditMaterial']['multi_share_optimized_text']}}</span
                      >
                    </label>
                  </div>
                </div>
                <div class="space-y-2 pb-8 my-4">
                  <label class="inline-flex items-center mt-3 w-full" v-if="item.type == 1 && this.goalsObjectiveData == 'VIDEO_VIEWS'">
                    <input type="checkbox" :disabled="editPageType" v-model="item.videoIsRequired"/>
                    <span class="ml-2 text-gray-700 text-sm"
                      >{{lang['components']['Event']['EditMaterial']['carousel_website']}}</span
                    >
                  </label>
                  <div>
                    <span class="text-grap-700 align-middle text-sm"
                      v-if="item.type == 1"
                      >{{lang['components']['Event']['EditMaterial']['material_message_type_1']}}</span
                    >
                    <span class="text-grap-700 align-middle text-sm"
                      v-if="item.type == 2"
                      >{{lang['components']['Event']['EditMaterial']['material_message_type_2']}}</span
                    >
                    <textarea
                      class="w-full h-24 px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      :placeholder="lang['components']['Event']['EditMaterial']['material_message_placeholder']"
                      :disabled="editPageType"
                      v-model="item.message"
                      v-on:keyup="isChangeData()"
                    ></textarea>
                  </div>
                  <div v-if="item.type == 1 && item.videoIsRequired && optimizationAction != 'PAGE_LIKES'">
                    <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['EditMaterial']['material_single_title']}}</span>
                    <input
                      class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      :placeholder="lang['components']['Event']['EditMaterial']['material_single_title_placeholder']"
                      :disabled="editPageType"
                      v-model="item.materialSingle[0].title"
                      v-on:keyup="isChangeData()"
                    />
                  </div>
                  <div v-if="item.type == 1 && item.videoIsRequired && optimizationAction != 'PAGE_LIKES'">
                    <span v-if="this.goalsObjectiveData != 'VIDEO_VIEWS'" class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['EditMaterial']['material_single_not_video_description']}}</span>
                    <span v-if="this.goalsObjectiveData == 'VIDEO_VIEWS'" class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['EditMaterial']['material_single_is_video_description']}}</span>
                    <textarea
                      class="w-full h-24 px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      :placeholder="lang['components']['Event']['EditMaterial']['material_single_description_placeholder']"
                      :disabled="editPageType"
                      v-model="item.materialSingle[0].description"
                      v-on:keyup="isChangeData()"
                    ></textarea>
                  </div>
                  <div v-if="item.type == 1 && item.videoIsRequired && optimizationAction != 'PAGE_LIKES' && goalsObjectiveData != 'LEAD_GENERATION' && goalsObjectiveData != 'MESSAGES'">
                    <span v-if="this.goalsObjectiveData != 'VIDEO_VIEWS'" class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['EditMaterial']['item_not_video_link']}}</span>
                    <span v-if="this.goalsObjectiveData == 'VIDEO_VIEWS'" class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['EditMaterial']['item_is_video_link']}}</span>
                    <input
                      class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      :placeholder="lang['components']['Event']['EditMaterial']['item_link_placeholder']"
                      :disabled="editPageType"
                      v-model="item.link"
                      v-on:keyup="isChangeData()"
                    >
                  </div>
                  <div v-if="item.type == 1 && item.videoIsRequired && optimizationAction != 'PAGE_LIKES'">
                    <span v-if="this.goalsObjectiveData != 'VIDEO_VIEWS'" class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['EditMaterial']['item_not_video_caption']}}</span>
                    <span v-if="this.goalsObjectiveData == 'VIDEO_VIEWS'" class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['EditMaterial']['item_is_video_caption']}}</span>
                    <input
                      class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      :placeholder="lang['components']['Event']['EditMaterial']['item_caption_placeholder']"
                      :disabled="editPageType"
                      v-model="item.caption"
                      v-on:keyup="isChangeData()"
                    >
                  </div>
                </div>
                <!-- <div
                  class="text-sm text-blue-300 underline cursor-pointer"
                  @click="moreInput = !moreInput"
                >
                  {{ moreWording }}更多選項
                  <i
                    class="pi"
                    :class="[moreInput ? 'pi-caret-up' : 'pi-caret-down']"
                    style="fontSize: 0.8rem"
                  ></i>
                </div> -->
                <!-- <div class="space-y-2 pb-8 my-4" v-show="moreInput"> -->
                <div v-if="item.videoIsRequired" class="space-y-2 pb-8 my-4">
                  <div class="flex flex-col">
                    <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['EditMaterial']['call_active_text']}}</span>
                    <Dropdown
                      :disabled="editPageType"
                      v-model="item.callActive"
                      optionLabel="name"
                      optionValue="code"
                      :options="optimizationAction == 'PAGE_LIKES' ? [{name: '追蹤', code: 'LIKE_PAGE'}] : callActiveList[this.goalsObjectiveData]"
                      :placeholder="lang['components']['Event']['EditMaterial']['call_active_placeholder']"
                      v-on:change="isChangeData()"
                      class="w-1/3 rounded-md"
                    />
                  </div>
                </div>
              </TabPanel>
            </template>
          </TabView>
        </div>
      </div>

      <div v-if="goalsObjectiveData === 'MESSAGES'">
        <Msg
          v-bind:pageId="this.pageId"
          v-bind:lang="lang"
          v-bind:messageId="currentMessageId"
          v-bind:editPage="editPageType"
          @childChangeMessageId="onMessageChange"
        />
      </div>

      <div class="hidden lg:block w-1/4 rounded-xl space-y-2 px-4 event-tips-sidebar">
        <div class="flex flex-col bg-white rounded-xl space-y-2 p-4">
          <div v-html="prview_now" v-if="prview_now"></div>
          <div v-html="prview_single" v-if="prview_single"></div>
        </div>
      </div>

      <!-- <div class="w-1/4 rounded-xl space-y-2 px-4">
        <div class="flex flex-col bg-white rounded-xl space-y-2 p-4">
          <div class="flex justify-between">
            <span class="text-gray-700">預覽</span>
            <div class="bg-gray-500 text-white rounded-xl">
              <a href="javascript:void(0);"
                ><i class="pi pi-angle-left mx-2"></i
              ></a>
              <a href="javascript:void(0);"
                ><i class="pi pi-angle-right mx-2"></i
              ></a>
            </div>
          </div>
          <hr class="-mx-4" />
          <div class="overflow-hidden w-full">
            <div class="flex">
              <div class="md:flex-shrink-0">
                <img
                  class="h-8 w-8 rounded-2xl object-cover"
                  src="http://placehold.it/100x100"
                />
              </div>
              <div class="mx-2">
                <p class="text-gray-800 text-xs">寓意科技</p>
                <p class="text-gray-500 text-xs">
                  <img :src="fb1Image" class="h-3" />
                </p>
              </div>
              <i
                class="pi pi-ellipsis-h m-auto w-1/3 text-right"
                style="fontSize: 0.8rem"
              ></i>
            </div>
          </div>
          <div class="text-sm">貼文內容貼文內容貼文內容</div>
          <div class="border-b border-gray-400">
            <img src="http://placehold.it/800x600" class="w-full" />
            <div class="flex justify-between bg-gray-200 p-2">
              <div>
                <p class="text-gray-800 text-xs">EXAMPLE.COM</p>
                <p class="text-gray-500 text-xs">標題</p>
              </div>
              <button
                class="text-xs border border-gray-400 text-gray-400 rounded-md h-6"
              >
                發送訊息
              </button>
            </div>
          </div>
          <img :src="fb2Image" alt="" />
        </div>
      </div> -->

      <!-- <ModifyWindows v-model:show="showVideoWindows" size="sm"> -->
      <ModifyWindows v-model:show="showVideoWindows">
        <template v-slot:header>
          <div class="flex flex-wrap gap-2 items-center">
          <span class="mr-2 text-lg lg:text-2xl font-semibold align-sub w-full lg:w-auto">{{lang['components']['Event']['EditMaterial']['material_block_title']}}</span>
          <button @click="materialUpdate()" class="button border-blue">
            {{lang['components']['Event']['EditMaterial']['material_block_update']}}
          </button>
          <button v-if="false" @click="$refs.videoUpload.click()" class="button border-blue">
            <img
              class="mr-2 inline-block align-baseline"
              src="../../assets/upload.svg"
            />{{lang['components']['Event']['EditMaterial']['material_block_upload']}}
          </button>
          <input ref="videoUpload" type="file" class="hidden" />
          {{lang['components']['Event']['EditMaterial']['material_block_title_info']}}
          </div>
        </template>

        <template v-slot:content>
          <loading :active="!showVideoLoading"
                  :can-cancel="true"
                  :is-full-page="false"
                  :color="'#fff'"
                  :background-color="'#000'"
                  :opacity="'0.8'">
          </loading>
          <div class="flex flex-wrap p-2 w-full h-full scrollbar-y" style="position:relative">
            <div v-if="this.goalsObjectiveData != 'VIDEO_VIEWS'" class="w-full">
               <span class="text-grap-700 align-middle">{{lang['components']['Event']['EditMaterial']['material_block_image']}}</span>
            </div>
            <div
              v-if="this.goalsObjectiveData != 'VIDEO_VIEWS'"
              v-for="(item, i) in image.imageList"
              :key="i"
            class="w-1/2 lg:w-auto flex flex-col items-center"
            >
              <img
                @click="changeSelectedForm(i, 'image')"
                :class="{ 'border-blue-light': image.active == i }"
                :src="image.imageList[i]"
                class="
                  flex-none
                  m-2
                  mb-4
                  w-24
                  h-24
                  border-4 border-transparent
                  object-cover
                  rounded-xl
                  cursor-pointer
                "
                :title="image.imageListTitle[i]"
              />
              <div
                class="text-center -mt-2 w-28 truncate"
              >
                {{image.imageListName[i]}}
              </div>
            </div>
            <div v-if="imageAfter != ''" class="w-full mt-4 text-center">
              <button
                class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
                @click="moreImage()"
              >{{lang['components']['Event']['EditMaterial']['material_block_image_more']}}</button>
            </div>
            <div class="w-full border-t-2 mt-20">
               <span class="text-grap-700 align-middle">{{lang['components']['Event']['EditMaterial']['material_block_video']}}</span>
            </div>
            <div
              v-for="(item, i) in video.videoList"
              :key="i"
            class="w-1/2 lg:w-auto flex flex-col items-center"
            >
              <img
                @click="changeSelectedForm(i, 'video')"
                :class="{ 'border-blue-light': video.active == i }"
                :src="video.videoList[i]"
                class="
                  flex-none
                  m-2
                  mb-4
                  w-24
                  h-24
                  border-4 border-transparent
                  object-cover
                  rounded-xl
                  cursor-pointer
                "
                :title="video.videoListTitle[i]"
              />
              <div
                class="text-center -mt-2 w-28 truncate"
              >
                {{video.videoListName[i]}}
              </div>
            </div>
            <div v-if="videoAfter != ''" class="w-full mt-4 text-center">
              <button
                class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
                @click="moreVideo()"
              >{{lang['components']['Event']['EditMaterial']['material_block_video_more']}}</button>
            </div>
          </div>
        </template>

        <template v-slot:footer>
          <div class="text-right">
            <button @click="setMaterial(currentTab)" class="button bg-yellow">{{lang['components']['Event']['EditMaterial']['set_material']}}</button>
          </div>
        </template>
      </ModifyWindows>
    </div>
    <template #footer>
      <div class="w-full flex flex-wrap justify-end py-4 border-t border-gray-400">
        <button
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-gray-400 transition duration-500 ease-in-out border-2"
          @click="showAddModal=false">{{lang['components']['Event']['EditMaterial']['cancel_button']}}</button>
        <button
          class="bg-yellow-400 hover:bg-yellow-200 focus:outline-none rounded-xl px-4 py-1 mx-auto text-blue-800 transition duration-500 ease-in-out border-2 border-yellow-400"
          
          @click="save()">{{lang['components']['Event']['EditMaterial']['save_button']}}</button>
      </div>
    </template>
  </Dialog>
</template>
<script>
import Dialog from 'primevue/dialog';
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Dropdown from "primevue/dropdown";
import InputSwitch from 'primevue/inputswitch';
import fb1Image from "@/assets/fb_1.png";
import fb2Image from "@/assets/fb_2.png";
import ModifyWindows from "@/components/ModifyWindows.vue";
import draggable from "vuedraggable";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import axios from 'axios'
import Qs from 'qs'
import Msg from '@/views/Msg.vue'

export default {
  name: "AdvertisingMaterial",
  components: {
    Dialog,
    TabView,
    TabPanel,
    Dropdown,
    InputSwitch,
    ModifyWindows,
    draggable,
    Swal,
    Loading,
    Msg
  },
  props: {
    showAdd: {
      type: Boolean,
      default: false
    },
    editPage: {
      type: Boolean
    },
    creativeDataId: {
      type: Number
    },
    returnCampaignObjective: {
      type: String
    },
    pageId: {
      type: String
    },
    goalsObjectiveData: {
      type: String
    },
    optimizationAction: {
      type: String,
      default: ''
    },
    campaignId: {
      type: String
    },
    lang: {
      type: Object
    },
    showTargetCR: {
      type: Boolean
    },
    showOtherTargetCR: {
      type: Boolean
    },
  },
  data() {
    return {
      isEdit: false,
      showSelectPostDialogMyside: false,
      showMaterialSingle: true,
      showMaterial: true,
      showVideoLoading: true,
      currentTab: 0,
      fb1Image: fb1Image,
      fb2Image: fb2Image,
      auto: true,
      type: 1,
      activeType: 1,
      activeItem: 0,
      focusType: 0,
      selectedForm: 'image',
      prview_now: null,
      prview_single: null,
      // videoIsRequired: true,
      nowItemIndex: 0,
      materials: [
        {
          imgSrc: null,
          title: "",
          description: "",
          website: "",
          isEdit: false
        },
        {
          imgSrc: "http://placehold.it/100x100",
          title: "",
          description: "",
          website: "",
          isEdit: false
        }
      ],
      showModal: false,
      call: null,
      moreInput: true,
      items: [
        {
          title: "xxxx",
          isEdit: false,
          type: 1,
          videoIsRequired: true,
          materials: [
            {
              id: null,
              imgSrc: null,
              object_spec: {
                name: null,
                width: null,
                height: null
              },
              title: null,
              description: null,
              website: null,
              isEdit: false,
              index: 0
            },
            {
              id: null,
              imgSrc: null,
              object_spec: {
                name: null,
                width: null,
                height: null
              },
              title: null,
              description: null,
              website: null,
              isEdit: false,
              index: 1
            }
          ],
          materialSingle: [
            {
              id: null,
              imgSrc: null,
              object_spec: {
                name: null,
                width: null,
                height: null
              },
              fileName: null,
              title: null,
              description: null,
              website: null,
              size: null,
              index: 0
            }
          ],
          callActive: 'SIGN_UP'
        },
        // {
        //   title: "廣告2",
        //   isEdit: false,
        //   type: 2,
        //   materials: [
        //     {
        //       imgSrc: null,
        //       title: "title1",
        //       description: "des1",
        //       website: "autoturn",
        //       isEdit: false
        //     },
        //     {
        //       imgSrc: "http://placehold.it/100x100",
        //       title: "title2",
        //       description: "des2",
        //       website: "fb",
        //       isEdit: false
        //     }
        //   ],
        //   callActive: 'SIGN_UP'
        // },
        // {
        //   title: "廣告1231232",
        //   isEdit: false,
        //   type: 1,
        //   materialSingle: [
        //     {
        //       src: "http://placehold.it/100x100",
        //       title: "test3333",
        //       size: "300*400"
        //     }
        //   ],
        //   callActive: 'BOOK_TRAVEL'
        // }
      ],
      showVideoWindows: false,
      image: {
        active: null,
        imageList: [
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg"
        ],
        imageListSpec: [],
        imageListName: [],
        imageListTitle: []
      },
      video: {
        active: null,
        videoList: [
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg"
        ],
        videoListSpec: [],
        videoListName: [],
        videoListTitle: []
      },
      imageAfter: '',
      videoAfter: '',
      materialSingle: [
        {
          src: "http://placehold.it/100x100",
          title: "test",
          size: "800*800"
        }
      ],
      callActiveFocusNow: null,
      callActiveFocus: {
        'CONVERSIONS': 'LEARN_MORE',
        'LINK_CLICKS': 'LEARN_MORE',
        'POST_ENGAGEMENT': 'NO_BUTTON',
        'VIDEO_VIEWS': 'LEARN_MORE',
        'MESSAGES': 'MESSAGE_PAGE',
      },
      callActiveList: {},
      // callActiveList: [
      //   {
      //     name: '立即申請',
      //     code: 'APPLY_NOW'
      //   },
      //   {
      //     name: '搶先預約',
      //     code: 'BOOK_TRAVEL'
      //   },
      //   {
      //     name: '下載',
      //     code: 'DOWNLOAD'
      //   },
      //   {
      //     name: '領取優惠',
      //     code: 'GET_OFFER'
      //   },
      //   {
      //     name: '取得報價',
      //     code: 'GET_QUOTE'
      //   },
      //   {
      //     name: '瞭解詳情',
      //     code: 'LEARN_MORE'
      //   },
      //   {
      //     name: '立即註冊',
      //     code: 'SIGN_UP'
      //   },
      //   {
      //     name: '訂閱',
      //     code: 'SUBSCRIBE'
      //   },
      //   {
      //     name: '發送訊息',
      //     code: 'MESSAGE_PAGE'
      //   },
      // ]
    };
  },
  watch: {
    lang(value){
    //  console.log('watch lang value');
    //  console.log(value);
      // this.callActiveList = {
      //     'CONVERSIONS': [
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['no_button'], code: 'NO_BUTTON' },
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['book_travel'], code: 'BOOK_TRAVEL'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['contact_us'], code: 'CONTACT_US'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['download'], code: 'DOWNLOAD'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['get_offer'], code: 'GET_OFFER'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['get_quote'], code: 'GET_QUOTE'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['get_showtimes'], code: 'GET_SHOWTIMES'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['listen_now'], code: 'LISTEN_NOW'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['order_now'], code: 'ORDER_NOW'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['play_game'], code: 'PLAY_GAME'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['request_time'], code: 'REQUEST_TIME'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['see_menu'], code: 'SEE_MENU'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['shop_now'], code: 'SHOP_NOW'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['sign_up'], code: 'SIGN_UP'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['subscribe'], code: 'SUBSCRIBE'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['watch_more'], code: 'WATCH_MORE'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['learn_more'], code: 'LEARN_MORE'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['apply_now'], code: 'APPLY_NOW'},
      //     ],
      //     'LINK_CLICKS': [
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['no_button'], code: 'NO_BUTTON' },
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['book_travel'], code: 'BOOK_TRAVEL'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['contact_us'], code: 'CONTACT_US'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['download'], code: 'DOWNLOAD'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['get_offer'], code: 'GET_OFFER'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['get_quote'], code: 'GET_QUOTE'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['pay_to_access'], code: 'PAY_TO_ACCESS'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['get_showtimes'], code: 'GET_SHOWTIMES'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['listen_now'], code: 'LISTEN_NOW'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['order_now'], code: 'ORDER_NOW'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['request_time'], code: 'REQUEST_TIME'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['see_menu'], code: 'SEE_MENU'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['shop_now'], code: 'SHOP_NOW'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['sign_up'], code: 'SIGN_UP'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['subscribe'], code: 'SUBSCRIBE'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['watch_more'], code: 'WATCH_MORE'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['learn_more'], code: 'LEARN_MORE'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['apply_now'], code: 'APPLY_NOW'},
      //     ],
      //     'POST_ENGAGEMENT': [
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['post_engagement']['no_button'], code: 'NO_BUTTON' },
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['post_engagement']['get_quote'], code: 'GET_QUOTE'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['post_engagement']['learn_more'], code: 'LEARN_MORE'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['post_engagement']['message_page'], code: 'MESSAGE_PAGE'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['post_engagement']['shop_now'], code: 'SHOP_NOW'},
      //     ],
      //     'VIDEO_VIEWS': [
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['book_travel'], code: 'BOOK_TRAVEL'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['download'], code: 'DOWNLOAD'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['get_quote'], code: 'GET_QUOTE'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['get_showtimes'], code: 'GET_SHOWTIMES'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['listen_now'], code: 'LISTEN_NOW'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['shop_now'], code: 'SHOP_NOW'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['sign_up'], code: 'SIGN_UP'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['subscribe'], code: 'SUBSCRIBE'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['watch_more'], code: 'WATCH_MORE'},
      //       { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['learn_more'], code: 'LEARN_MORE'},
      //     ],
      //   };
    },
    creativeDataId (value){
    //  console.log('creativeDataId');
    //  console.log(this.creativeDataId);
    //  console.log(value);

      // let member_hash = this.$route.params.id;

      // axios
      //   .post('https://www.autoturn.net/api/customize/campaign/creative_edit_view.php', Qs.stringify({
      //     s_code: member_hash,
      //     item_id: value,
      //   }))
      //   .then((caResponse) => {
      //   //  console.log('caResponse:');
      //   //  console.log(caResponse);

      //     this.items = caResponse.data.return_data.creative_array;

      //     // this.showSelectPostDialogMyside = false;
      //     // if(caResponse.data.status == 'success'){

      //     //   this.$emit('update:creativesDatalist', caResponse.data.return_data)
      //     //   this.$emit('update:prviewCreativesDatalist', caResponse.data.return_prview)
      //     //   this.$emit('childAddMaterial', true)

      //     //   Swal.fire({
      //     //     icon: 'success',
      //     //     title: this.lang['components']['Event']['EditMaterial']['methods']['save']['item']['swal_title'],
      //     //     text: this.lang['components']['Event']['EditMaterial']['methods']['save']['item']['status_success_swal_text'],
      //     //     showDenyButton: false,
      //     //     showCancelButton: false,
      //     //     confirmButtonText: this.lang['components']['Event']['EditMaterial']['methods']['save']['item']['confirm_button'],
      //     //     // denyButtonText: `Don't save`,
      //     //   }).then((result) => {
      //     //     if (result.isConfirmed) {
      //     //       // Swal.fire('Saved!', '', 'success')
      //     //       this.showAddModal = false
      //     //     } else if (result.isDenied) {
      //     //       // Swal.fire('Changes are not saved', '', 'info')
      //     //       this.showAddModal = false
      //     //     }
      //     //   })
      //     // } else {
      //     //   Swal.fire({
      //     //     icon: 'error',
      //     //     title: this.lang['components']['Event']['EditMaterial']['methods']['save']['item']['swal_title'],
      //     //     text: caResponse.data.info,
      //     //     showDenyButton: false,
      //     //     showCancelButton: false,
      //     //     confirmButtonText: this.lang['components']['Event']['EditMaterial']['methods']['save']['item']['confirm_button'],
      //     //     // denyButtonText: `Don't save`,
      //     //   }).then((result) => {
      //     //     if (result.isConfirmed) {
      //     //       // Swal.fire('Saved!', '', 'success')
      //     //       this.showAddModal = false
      //     //     } else if (result.isDenied) {
      //     //       // Swal.fire('Changes are not saved', '', 'info')
      //     //       this.showAddModal = false
      //     //     }
      //     //   })
      //     // }
      //   });
    },
    showAdd(value){
    //  console.log('showAdd');
    //  console.log(value);
      if(value == true){
        this.callActiveList = {
          'CONVERSIONS': [
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['no_button'], code: 'NO_BUTTON' },
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['book_travel'], code: 'BOOK_TRAVEL'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['contact_us'], code: 'CONTACT_US'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['download'], code: 'DOWNLOAD'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['get_offer'], code: 'GET_OFFER'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['get_quote'], code: 'GET_QUOTE'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['get_showtimes'], code: 'GET_SHOWTIMES'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['listen_now'], code: 'LISTEN_NOW'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['order_now'], code: 'ORDER_NOW'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['play_game'], code: 'PLAY_GAME'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['request_time'], code: 'REQUEST_TIME'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['see_menu'], code: 'SEE_MENU'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['shop_now'], code: 'SHOP_NOW'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['sign_up'], code: 'SIGN_UP'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['subscribe'], code: 'SUBSCRIBE'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['watch_more'], code: 'WATCH_MORE'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['learn_more'], code: 'LEARN_MORE'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['conversions']['apply_now'], code: 'APPLY_NOW'},
          ],
          'LINK_CLICKS': [
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['no_button'], code: 'NO_BUTTON' },
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['book_travel'], code: 'BOOK_TRAVEL'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['contact_us'], code: 'CONTACT_US'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['download'], code: 'DOWNLOAD'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['get_offer'], code: 'GET_OFFER'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['get_quote'], code: 'GET_QUOTE'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['pay_to_access'], code: 'PAY_TO_ACCESS'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['get_showtimes'], code: 'GET_SHOWTIMES'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['listen_now'], code: 'LISTEN_NOW'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['order_now'], code: 'ORDER_NOW'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['request_time'], code: 'REQUEST_TIME'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['see_menu'], code: 'SEE_MENU'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['shop_now'], code: 'SHOP_NOW'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['sign_up'], code: 'SIGN_UP'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['subscribe'], code: 'SUBSCRIBE'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['watch_more'], code: 'WATCH_MORE'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['learn_more'], code: 'LEARN_MORE'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['link_clicks']['apply_now'], code: 'APPLY_NOW'},
          ],
          'POST_ENGAGEMENT': [
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['post_engagement']['no_button'], code: 'NO_BUTTON' },
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['post_engagement']['get_quote'], code: 'GET_QUOTE'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['post_engagement']['learn_more'], code: 'LEARN_MORE'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['post_engagement']['message_page'], code: 'MESSAGE_PAGE'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['post_engagement']['shop_now'], code: 'SHOP_NOW'},
          ],
          'VIDEO_VIEWS': [
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['book_travel'], code: 'BOOK_TRAVEL'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['download'], code: 'DOWNLOAD'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['get_quote'], code: 'GET_QUOTE'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['get_showtimes'], code: 'GET_SHOWTIMES'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['listen_now'], code: 'LISTEN_NOW'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['shop_now'], code: 'SHOP_NOW'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['sign_up'], code: 'SIGN_UP'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['subscribe'], code: 'SUBSCRIBE'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['watch_more'], code: 'WATCH_MORE'},
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['video_views']['learn_more'], code: 'LEARN_MORE'},
          ],
          'MESSAGES': [
            { name: this.lang['components']['Event']['EditMaterial']['call_active_list']['messages']['message_page'], code: 'MESSAGE_PAGE'},
          ],
        };

        this.prview_single = null;

        // if(this.goalsObjectiveData == 'VIDEO_VIEWS'){
        //   this.videoIsRequired = false;
        // } else {
        //   this.videoIsRequired = true;
        // }

        let member_hash = this.$route.params.id;

        axios
          .post('https://www.autoturn.net/api/customize/campaign/creative_edit_view.php', Qs.stringify({
            s_code: member_hash,
            item_id: this.creativeDataId,
          }))
          .then((caResponse) => {
          //  console.log('caResponse:');
          //  console.log(caResponse);

            this.items = caResponse.data.return_data.creative_array;

            // 解析 enhancements
            for(let i = 0; i < this.items.length; i++){
              if(this.items[i].enhancements){
                let enh = JSON.parse(this.items[i].enhancements);
                this.items[i].visual_touchup = enh.visual_touchup == "1";
                this.items[i].add_animation = enh.add_animation == "1";
                this.items[i].flexible_media = enh.flexible_media == "1";
              } else {
                this.items[i].visual_touchup = false;
                this.items[i].add_animation = false;
                this.items[i].flexible_media = false;
              }
            }

            if(this.optimizationAction == 'PAGE_LIKES'){
              for(let i = 0; i < this.items.length; i++){
                this.items[i].callActive = 'LIKE_PAGE';
              }
            }
          });

        // this.items = [
        //   {
        //     title: "xxxx",
        //     isEdit: false,
        //     type: 1,
        //     videoIsRequired: true,
        //     materials: [
        //       {
        //         id: null,
        //         imgSrc: null,
        //         object_spec: {
        //           name: null,
        //           width: null,
        //           height: null
        //         },
        //         title: null,
        //         description: null,
        //         website: null,
        //         isEdit: false,
        //         index: 0
        //       },
        //       {
        //         id: null,
        //         imgSrc: null,
        //         object_spec: {
        //           name: null,
        //           width: null,
        //           height: null
        //         },
        //         title: null,
        //         description: null,
        //         website: null,
        //         isEdit: false,
        //         index: 1
        //       }
        //     ],
        //     materialSingle: [
        //       {
        //         id: null,
        //         imgSrc: null,
        //         object_spec: {
        //           name: null,
        //           width: null,
        //           height: null
        //         },
        //         fileName: null,
        //         title: null,
        //         description: null,
        //         website: null,
        //         size: null,
        //         index: 0
        //       }
        //     ],
        //     callActive: this.callActiveFocus[this.goalsObjectiveData]
        //   },
        // ]

      }
    },
    videoIsRequired(value){
      // console.log('videoIsRequired');
      // console.log(value);
      // console.log(this.items);
      this.items[this.nowItemIndex].materialSingle[0].title = '';
      this.items[this.nowItemIndex].materialSingle[0].description = '';
      this.items[this.nowItemIndex].link = '';
      this.items[this.nowItemIndex].caption = '';
    }
  },
  methods: {
    unlock(){
      this.isEdit = false
    },
    lock(){
      this.isEdit = true
    },
    changeType(index, value){
      if(this.editPageType == false){
        this.items[index].type = value
        this.focusType = index

        // console.log('changeType');
        // console.log('items['+index+'].type');
        // console.log(this.items[index].type);
        // console.log('focusType');
        // console.log(this.focusType);
      }
    },
    changeSelectedForm(index, value){
      if(this.editPageType == false){
        if(value == 'image'){
          this.image.active = index
          this.selectedForm = 'image'
        } else {
          this.video.active = index
          this.selectedForm = 'video'
        }
      }
    },
    addItem() {
      // this.items.push({ title: "xxxxxx" });
      if(this.editPageType == false){
        this.items.push(
          {
            title: "廣告xxxx",
            isEdit: false,
            type: 1,
            videoIsRequired: true,
            materials: [
              {
                id: null,
                imgSrc: null,
                object_spec: {
                  name: null,
                  width: null,
                  height: null
                },
                title: null,
                description: null,
                website: null,
                isEdit: false,
                index: 0
              },
              {
                id: null,
                imgSrc: null,
                object_spec: {
                  name: null,
                  width: null,
                  height: null
                },
                title: null,
                description: null,
                website: null,
                isEdit: false,
                index: 1
              }
            ],
            materialSingle: [
              {
                id: null,
                imgSrc: null,
                object_spec: {
                  name: null,
                  width: null,
                  height: null
                },
                fileName: null,
                title: null,
                description: null,
                website: null,
                size: null,
                index: 0
              }
            ],
            callActive: this.callActiveFocus[this.goalsObjectiveData],
            visual_touchup: false,
            add_animation: false,
            flexible_media: false
          }
        );

        this.$emit('childAdIsChangeData', true);
        this.$emit('childContent', this.items);
      }
    },
    setMaterial(type) {
      let activeType = this.activeType
      let activeItem = this.activeItem

      // console.log('setMaterial type:'+type);
      // console.log('setMaterial activeType:'+activeType);
      // console.log('setMaterial activeItem:'+activeItem);

      if(this.editPageType == false){
        if(activeType == 1){
          if(this.selectedForm == 'image'){
            if (
              this.image.active != null &&
              this.image.imageList.length > this.image.active
            ) {
              this.items.materialSingle == []

              // console.log('1 image this.image.active');
              // console.log(this.image.active);
              // console.log('this.image');
              // console.log(this.image);

              this.items[type].materialSingle = [{
                id: this.image.imageListSpec[this.image.active].id,
                imgSrc: this.image.imageList[this.image.active],
                object_spec: this.image.imageListSpec[this.image.active],
                fileName: this.image.imageListSpec[this.image.active].name,
                title: this.items[type].materialSingle[0].title,
                size: this.image.imageListSpec[this.image.active].width+' * '+this.image.imageListSpec[this.image.active].height,
                index: 0
              }];

              this.image.active = null;
              this.showVideoWindows = false;
            }
          } else {
            if (
              this.video.active != null &&
              this.video.videoList.length > this.video.active
            ) {
              this.items.materialSingle == []

              // console.log('1 video this.video.active');
              // console.log(this.video.active);
              // console.log('this.video');
              // console.log(this.video);

              this.items[type].materialSingle = [{
                id: this.video.videoListSpec[this.video.active].id,
                imgSrc: this.video.videoList[this.video.active],
                object_spec: this.video.videoListSpec[this.video.active],
                fileName: this.video.videoListSpec[this.video.active].title,
                title: this.items[type].materialSingle[0].title,
                size: this.video.videoListSpec[this.video.active].width+' * '+this.video.videoListSpec[this.video.active].height,
                index: 0
              }];

              this.video.active = null;
              this.showVideoWindows = false;
            }
          }
        }

        if(activeType == 2){
          let this_length = this.items[type].materials.length;
          if(this.selectedForm == 'image'){
            if (
              this.image.active != null &&
              this.image.imageList.length > this.image.active
            ) {
              this.items.materials == []

              // console.log('2 image this.image.active');
              // console.log(this.image.active);
              // console.log(this.image.imageList[this.image.active]);
              // console.log(this.items);
              // console.log(this.items[activeType]);
              // console.log('this.image');
              // console.log(this.image);

              // this.items[activeType].materials.push({
              //   imgSrc: this.image.imageList[this.image.active],
              //   title: "",
              //   size: "800*800"
              // });

              if(typeof this.items[type].materials[activeItem].index != 'undefined'){
                this_length = this.items[type].materials[activeItem].index;
              }

              this.items[type].materials[activeItem] = {
                id: this.image.imageListSpec[this.image.active].id,
                imgSrc: this.image.imageList[this.image.active],
                object_spec: this.image.imageListSpec[this.image.active],
                title: this.items[type].materials[activeItem].title,
                size: "800*800",
                isEdit: true,
                index: this_length
              };

              // console.log(this.items[type]);

              this.image.active = null;
              this.showVideoWindows = false;
            }
          } else {
            if (
              this.video.active != null &&
              this.video.videoList.length > this.video.active
            ) {
              this.items.materials == []

              // console.log('2 video this.video.active');
              // console.log(this.video.active);
              // console.log('this.video');
              // console.log(this.video);

              // this.items[activeType].materials.push({
              //   imgSrc: this.video.videoList[this.video.active],
              //   title: "",
              //   size: "800*800"
              // });

              if(typeof this.items[type].materials[activeItem].index != 'undefined'){
                this_length = this.items[type].materials[activeItem].index;
              }

              this.items[type].materials[activeItem] = {
                id: this.video.videoListSpec[this.video.active].id,
                imgSrc: this.video.videoList[this.video.active],
                object_spec: this.video.videoListSpec[this.video.active],
                title: this.items[type].materials[activeItem].title,
                size: "800*800",
                isEdit: true,
                index: this_length
              };

              this.video.active = null;
              this.showVideoWindows = false;
            }
          }
        }

      //  console.log('this.items');
      //  console.log(this.items);

        this.$emit('childAdIsChangeData', true);
        this.$emit('childContent', this.items);

        this.adPreview(this.currentTab);
      }

      // console.log('this.items');
      // console.log(this.items);
    },
    getImageVideoList(type, index){
    //  console.log('getImageVideoList type:'+type);
    //  console.log('getImageVideoList index:');
    //  console.log(index);

      // if(this.editPageType == false){

        // if(type == 1){
        //   this.showMaterialSingle = false;
        // } else {
        //   this.showMaterial = false;
        // }

        this.showVideoWindows = true;
        this.showVideoLoading = false;

        this.image.imageList = null;
        this.image.imageListSpec = null;
        this.image.imageListName = null;
        this.image.imageListTitle = null;
        this.video.videoList = null;
        this.video.videoListSpec = null;
        this.video.videoListName = null;
        this.video.videoListTitle = null;

        this.activeType = null;
        this.activeItem = null;

        axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_adimages.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.imageAfter = response.data.after_image

              this.image.imageList = response.data.return_image
              this.image.imageListSpec = response.data.return_image_spec
              this.image.imageListName = response.data.return_image_name
              this.image.imageListTitle = response.data.return_image_title

              // this.activeType = type
              // this.activeItem = index

              // this.showVideoLoading = true;

              axios
              .post('https://www.autoturn.net/api/customize/campaign/campaign_form_advideos.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
              }))
              .then((response) => {
                // if(response.data.status == 'success'){
                  this.videoAfter = response.data.after_video

                  this.video.videoList = response.data.return_video
                  this.video.videoListSpec = response.data.return_video_spec
                  this.video.videoListName = response.data.return_video_name
                  this.video.videoListTitle = response.data.return_video_title

                  this.activeType = type
                  this.activeItem = index

                  // if(type == 1){
                  //   this.showMaterialSingle = true;
                  // } else {
                  //   this.showMaterial = true;
                  // }

                  // this.showVideoWindows = true

                  this.showVideoLoading = true;
                // }
              });
            } else {
              axios
              .post('https://www.autoturn.net/api/customize/campaign/campaign_form_advideos.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
              }))
              .then((response) => {
                // if(response.data.status == 'success'){
                  this.videoAfter = response.data.after_video

                  this.video.videoList = response.data.return_video
                  this.video.videoListSpec = response.data.return_video_spec
                  this.video.videoListName = response.data.return_video_name
                  this.video.videoListTitle = response.data.return_video_title

                  this.activeType = type
                  this.activeItem = index

                  // if(type == 1){
                  //   this.showMaterialSingle = true;
                  // } else {
                  //   this.showMaterial = true;
                  // }

                  // this.showVideoWindows = true

                  this.showVideoLoading = true;
                // }
              });
            }
          });
      // }
    },
    moreVideo(){
    //  console.log('moreVideo');

      // let thisVideoList = ['video111.jpg','video222.jpg'];
      // let thisVideoListSpec = ['111','222'];
      // let thisVideoListName = ['video111','video222'];
      // let thisVideoListTitle = ['video111','video222'];

      this.showVideoLoading = false;

      axios
        .post('https://www.autoturn.net/api/customize/campaign/campaign_form_advideos.php', Qs.stringify({
          s_code: this.$route.params.id,
          adaccount_id: this.$route.params.adaccount_id,
          video_material_code: this.videoAfter,
        }))
        .then((response) => {
          // if(response.data.status == 'success'){
            // this.video.videoList = response.data.return_video
            // this.video.videoListSpec = response.data.return_video_spec
            // this.video.videoListName = response.data.return_video_name
            // this.video.videoListTitle = response.data.return_video_title

            // if(type == 1){
            //   this.showMaterialSingle = true;
            // } else {
            //   this.showMaterial = true;
            // }

            // this.showVideoWindows = true

            // this.showVideoLoading = true;
            this.videoAfter = response.data.after_video;

            this.video.videoList = response.data.return_video;
            this.video.videoListSpec = response.data.return_video_spec;
            this.video.videoListName = response.data.return_video_name;
            this.video.videoListTitle = response.data.return_video_title;

            this.showVideoLoading = true;
          // }
        });
    },
    moreImage(){
    //  console.log('moreImage');

      // let thisImageList = ['image111.jpg','image222.jpg'];
      // let thisImageListSpec = ['111','222'];
      // let thisImageListName = ['image111','image222'];
      // let thisImageListTitle = ['image111','image222'];

      this.showVideoLoading = false;

      axios
        .post('https://www.autoturn.net/api/customize/campaign/campaign_form_adimages.php', Qs.stringify({
          s_code: this.$route.params.id,
          adaccount_id: this.$route.params.adaccount_id,
          image_material_code: this.imageAfter,
        }))
        .then((response) => {
          // if(response.data.status == 'success'){
            // this.image.imageList = response.data.return_image
            // this.image.imageListSpec = response.data.return_image_spec
            // this.image.imageListName = response.data.return_image_name
            // this.image.imageListTitle = response.data.return_image_title

            // if(type == 1){
            //   this.showMaterialSingle = true;
            // } else {
            //   this.showMaterial = true;
            // }

            // this.showVideoWindows = true

            // this.showVideoLoading = true;
            this.imageAfter = response.data.after_image;

            this.image.imageList = response.data.return_image;
            this.image.imageListSpec = response.data.return_image_spec;
            this.image.imageListName = response.data.return_image_name;
            this.image.imageListTitle = response.data.return_image_title;

            this.showVideoLoading = true;
          // }
        });
    },
    adContent(index){
      // console.log('adContent');
      // console.log(index);
      // console.log(this.items[index].preview);
      // console.log(this.items[index]);

      // if(this.editPageType == false){
        this.currentTab = index
        this.prview_now = this.items[index].preview

        this.nowItemIndex = index;
        this.$emit('childFormId', this.items[index].form_sr_i);
        this.$emit('childMessageId', this.items[index].message_sr_i);
      // }
    },
    addMaterials(index){
      // console.log('addMaterials:'+index);
      let this_length = this.items[index].materials.length;

      if(this.editPageType == false){
        if(this_length < 10){
          this.items[index].materials.push({
            id: null,
            imgSrc: null,
            object_spec: {
              name: null,
              width: null,
              height: null
            },
            title: null,
            description: null,
            website: null,
            isEdit: false,
            index: this_length
          });

          this.$emit('childAdIsChangeData', true);
          this.$emit('childContent', this.items);
        } else {
          Swal.fire(
                    this.lang['components']['Event']['EditMaterial']['methods']['addMaterials']['not_length_swal_title'],
                    this.lang['components']['Event']['EditMaterial']['methods']['addMaterials']['not_length_swal_text'],
                    'warning'
                  );
        }
      }

      this.adPreview(this.currentTab);

      // console.log(this.items[index].materials);
    },
    removeAd(index){
      // console.log('removeAd index:'+index);

      if(this.editPageType == false){
        this.items.splice(index, 1);

        this.$emit('childAdIsChangeData', true);
        this.$emit('childContent', this.items);
      }
    },
    isChangeData(){
      // console.log('isChangeData');
      this.$emit('childAdIsChangeData', true);
      this.$emit('childContent', this.items);

      this.adPreview(this.currentTab);
    },
    onMessageChange(value) {
      if(value != null && value != '') {
        let get_value = value.split('_');
        this.items[this.currentTab].message_sr_i = parseInt(get_value[0]);
        this.isChangeData();
      }
    },
    removeItem(type, index){
      // console.log('removeItem type:'+type);
      // console.log('removeItem index:'+index);

      if(this.editPageType == false){
        // console.log('b this.items:');
        // console.log(this.items);
        // console.log('this.items['+type+'].materials:');
        // console.log(this.items[type].materials);
        this.items[type].materials.splice(index, 1);

        for(var i = 0; i < this.items[type].materials.length; i++){
          this.items[type].materials[i].index = i;
        }

        this.$emit('childAdIsChangeData', true);
        this.$emit('childContent', this.items);

        // console.log('a this.items:');
        // console.log(this.items);
      }
    },
    IsURL(str_url){
    //  console.log('str_url');
    //  console.log(str_url);
      // var strRegex = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
      // // var strRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
      // // var strRegex = /^(http|https):\/\/[\w\-_\u4E00-\u9FA5:/]+(\.[\w\-_\u4E00-\u9FA5]+)+([\u4E00-\u9FA5\w\-.,@?^=%&:/~+#]*[\u4E00-\u9FA5\w\-@?^=%&/~+#])?$/;
      // var re = new RegExp(strRegex);
      // //re.test()
      // if (re.test(str_url)){
      // //  console.log('#1');
        return true;
      // } else {
      // //  console.log('#2');
      //   return false;
      // }
    },
    save(){
      // console.log(this.items);
      // console.log('this.goalsObjectiveData:');
      // console.log(this.goalsObjectiveData);
      // console.log('this.campaignId');
      // console.log(this.campaignId);

    //  console.log('this.items');
    //  console.log(this.items);

      let needLink = 0;
      let formatLink = 0;
      let objectSpec = 0;
      let message = 0;
      let title = 0;
      let description = 0;
      let caption = 0;
      let material_message = 0;
      for(let i = 0; i < this.items.length; i++){
        if(this.items[i].type == 1){
          if(this.items[i].materialSingle[0].object_spec.id == null || this.items[i].materialSingle[0].object_spec.id == '' || typeof this.items[i].materialSingle[0].object_spec.id == 'undefined'){
            objectSpec = 1;
          }

          if((this.items[i].materialSingle[0].title == null || this.items[i].materialSingle[0].title == '' || typeof this.items[i].materialSingle[0].title == 'undefined') && this.goalsObjectiveData != 'VIDEO_VIEWS' && this.optimizationAction != 'PAGE_LIKES'){
            title = 1;
          }
        }

        if(this.items[i].type == 2){
          for(let j = 0; j < this.items[i].materials.length; j++){
            if(this.items[i].materials[j].object_spec.id == null || this.items[i].materials[j].object_spec.id == '' || typeof this.items[i].materials[j].object_spec.id == 'undefined'){
              objectSpec = 1;
            }

            if((this.items[i].materials[j].title == null || this.items[i].materials[j].title == '' || typeof this.items[i].materials[j].title == 'undefined') && this.optimizationAction != 'PAGE_LIKES'){
              title = 1;
            }
          }
        }

        if(this.items[i].message == null || this.items[i].message == '' || typeof this.items[i].message == 'undefined'){
          message = 1;
        }

        if((this.goalsObjectiveData == 'CONVERSIONS' || this.goalsObjectiveData == 'LINK_CLICKS') && this.optimizationAction != 'PAGE_LIKES'){
          if(this.items[i].type == 1){
            if(this.items[i].link == null || this.items[i].link == '' || typeof this.items[i].link == 'undefined'){
              if(this.items[i].callActive != 'NO_BUTTON'){
                needLink = 1;
              }
            }

            let items1_link = this.items[i].link
            if(this.IsURL(items1_link) == false){
              formatLink = 1;
            }
          }

          if(this.items[i].type == 2){
            for(let j = 0; j < this.items[i].materials.length; j++){
              if(this.items[i].materials[j].website == null || this.items[i].materials[j].website == '' || typeof this.items[i].materials[j].website == 'undefined'){
                if(this.items[i].callActive != 'NO_BUTTON'){
                  needLink = 1;
                }
              }

              let items2_link = this.items[i].materials[j].website
              if(this.IsURL(items2_link) == false){
                formatLink = 1;
              }
            }
          }
        }

        if(this.goalsObjectiveData == 'POST_ENGAGEMENT' && this.optimizationAction != 'PAGE_LIKES'){
          if(this.items[i].type == 1){
            if(this.items[i].link == null || this.items[i].link == '' || typeof this.items[i].link == 'undefined'){
              if(this.items[i].callActive != 'NO_BUTTON' && this.items[i].callActive != 'MESSAGE_PAGE'){
                needLink = 1;
              }
            }

            let items1_link = this.items[i].link
            if(this.IsURL(items1_link) == false){
              formatLink = 1;
            }
          }
        }

        if(this.goalsObjectiveData == 'VIDEO_VIEWS' && this.optimizationAction != 'PAGE_LIKES'){
          if(this.items[i].type == 1){
            if((this.items[i].materialSingle[0].title == null || this.items[i].materialSingle[0].title == '' || typeof this.items[i].materialSingle[0].title == 'undefined') && this.items[i].videoIsRequired == true){
              title = 1;
            }

            if((this.items[i].materialSingle[0].description == null || this.items[i].materialSingle[0].description == '' || typeof this.items[i].materialSingle[0].description == 'undefined') && this.items[i].videoIsRequired == true){
              description = 1;
            }

            if(this.items[i].link == null || this.items[i].link == '' || typeof this.items[i].link == 'undefined'){
              // if(this.items[i].caption != null && this.items[i].caption != '' && typeof this.items[i].caption != 'undefined'){
              //   needLink = 1;
              // }

              // if(this.items[i].materialSingle[0].description != null && this.items[i].materialSingle[0].description != '' && typeof this.items[i].materialSingle[0].description != 'undefined'){
              //   needLink = 1;
              // }
              if(this.items[i].videoIsRequired == true){
                needLink = 1;
              }
            }

            let items1_link = this.items[i].link
            if(this.IsURL(items1_link) == false){
              formatLink = 1;
            }

            if((this.items[i].caption == null || this.items[i].caption == '' || typeof this.items[i].caption == 'undefined') && this.items[i].videoIsRequired == true){
              caption = 1;
            }
          }
        }

        if(this.items[i].title == null || this.items[i].title == '' || typeof this.items[i].title == 'undefined'){
          material_message = 1;
        }
      }

      if(objectSpec == 1){
        Swal.fire(
                    this.lang['components']['Event']['EditMaterial']['methods']['save']['swal_title'],
                    this.lang['components']['Event']['EditMaterial']['methods']['save']['not_object_spec_swal_text'],
                    "error"
                  )
      } else if(message == 1){
        Swal.fire(
                    this.lang['components']['Event']['EditMaterial']['methods']['save']['swal_title'],
                    this.lang['components']['Event']['EditMaterial']['methods']['save']['not_message_swal_text'],
                    "error"
                  )
      } else if(title == 1){
        Swal.fire(
                    this.lang['components']['Event']['EditMaterial']['methods']['save']['swal_title'],
                    this.lang['components']['Event']['EditMaterial']['methods']['save']['not_title_swal_text'],
                    "error"
                  )
      } else if(description == 1 && this.goalsObjectiveData == 'VIDEO_VIEWS'){
        Swal.fire(
                    this.lang['components']['Event']['EditMaterial']['methods']['save']['swal_title'],
                    this.lang['components']['Event']['EditMaterial']['methods']['save']['not_description_swal_text'],
                    "error"
                  )
      } else if(caption == 1 && this.goalsObjectiveData == 'VIDEO_VIEWS'){
        Swal.fire(
                    this.lang['components']['Event']['EditMaterial']['methods']['save']['swal_title'],
                    this.lang['components']['Event']['EditMaterial']['methods']['save']['not_caption_swal_text'],
                    "error"
                  )
      } else if(needLink == 1){
        Swal.fire(
                    this.lang['components']['Event']['EditMaterial']['methods']['save']['swal_title'],
                    this.lang['components']['Event']['EditMaterial']['methods']['save']['not_link_swal_text'],
                    "error"
                  )
      } else if(formatLink == 1){
        Swal.fire(
                    this.lang['components']['Event']['EditMaterial']['methods']['save']['swal_title'],
                    this.lang['components']['Event']['EditMaterial']['methods']['save']['link_format_error_swal_text'],
                    "error"
                  )
      } else if(material_message == 1){
        Swal.fire(
                    this.lang['components']['Event']['EditMaterial']['methods']['save']['swal_title'],
                    this.lang['components']['Event']['EditMaterial']['methods']['save']['material_message_error_swal_text'],
                    "error"
                  )
      } else {
        // console.log('網址都有填');
        if(this.items.length > 0 && this.items != null || typeof this.items != 'undefined'){
          Swal.fire({
            title: this.lang['components']['Event']['EditMaterial']['methods']['save']['item']['swal_title'],
            html: this.lang['components']['Event']['EditMaterial']['methods']['save']['item']['swal_html_c'],
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.lang['components']['Event']['EditMaterial']['methods']['save']['item']['yes_button'],
            cancelButtonText: this.lang['components']['Event']['EditMaterial']['methods']['save']['item']['no_button'],
          }).then((result) => {
            if (result.isConfirmed) {
              // console.log(this.$route.params.id);
              this.showSelectPostDialogMyside = true;

              let member_hash = this.$route.params.id;
              let adaccount_id = this.$route.params.adaccount_id;

            //  console.log('creative_edit this.showTargetCR');
            //  console.log(this.showTargetCR);
            //  console.log('creative_edit this.showOtherTargetCR');
            //  console.log(this.showOtherTargetCR);

              let creativeEditUrl = 'https://www.autoturn.net/api/customize/data/creative_edit.php';
              if(this.showTargetCR == true || this.showOtherTargetCR == true){
                creativeEditUrl = 'https://www.autoturn.net/api/customize/data/stage_creative_edit.php';
              }

              axios
                .post(creativeEditUrl, Qs.stringify({
                  s_code: member_hash,
                  adaccount_id: adaccount_id,
                  page_id: this.pageId,
                  objective: this.goalsObjectiveData,
                  campaign_id:this.campaignId,
                  items: this.items,
                }))
                .then((caResponse) => {
                //  console.log('caResponse:');
                //  console.log(caResponse);

                  this.showSelectPostDialogMyside = false;
                  if(caResponse.data.status == 'success'){

                    if(this.goalsObjectiveData === 'MESSAGES'){
                      this.$emit('update:creativesMessageDatalist', caResponse.data.return_data)
                      this.$emit('update:prviewCreativesMessageDatalist', caResponse.data.return_prview)
                    } else {
                      this.$emit('update:creativesDatalist', caResponse.data.return_data)
                      this.$emit('update:prviewCreativesDatalist', caResponse.data.return_prview)
                    }
                    this.$emit('childAddMaterial', true)

                    Swal.fire({
                      icon: 'success',
                      title: this.lang['components']['Event']['EditMaterial']['methods']['save']['item']['swal_title'],
                      text: this.lang['components']['Event']['EditMaterial']['methods']['save']['item']['status_success_swal_text'],
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.lang['components']['Event']['EditMaterial']['methods']['save']['item']['confirm_button'],
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        this.showAddModal = false
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        this.showAddModal = false
                      }
                    })
                  } else {
                    Swal.fire({
                      icon: 'error',
                      title: this.lang['components']['Event']['EditMaterial']['methods']['save']['item']['swal_title'],
                      text: caResponse.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.lang['components']['Event']['EditMaterial']['methods']['save']['item']['confirm_button'],
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        // Swal.fire('Saved!', '', 'success')
                        this.showAddModal = false
                      } else if (result.isDenied) {
                        // Swal.fire('Changes are not saved', '', 'info')
                        this.showAddModal = false
                      }
                    })
                  }
                });
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: this.lang['components']['Event']['EditMaterial']['methods']['save']['not_item']['swal_title'],
            text: this.lang['components']['Event']['EditMaterial']['methods']['save']['not_item']['swal_text'],
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: this.lang['components']['Event']['EditMaterial']['methods']['save']['not_item']['confirm_button'],
            // denyButtonText: `Don't save`,
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              // Swal.fire('Saved!', '', 'success')
              // this.showAddModal = false
            } else if (result.isDenied) {
              // Swal.fire('Changes are not saved', '', 'info')
              // this.showAddModal = false
            }
          })
        }
      }
    },
    adPreview(index){
      // console.log(this.items[index]);

      axios
          .post('https://www.autoturn.net/api/customize/campaign/campaign_form_ad_preview.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            page_id: this.pageId,
            items: this.items[index]
          }))
          .then((response) => {
            // console.log(response.data);
            if(response.data.status == 'success'){

              this.prview_now = null;

              this.prview_single = response.data.return_data

              // console.log('this.prview_single');
              // console.log(this.prview_single);
              // this.image.imageList = response.data.return_image
              // this.image.imageListSpec = response.data.return_image_spec
              // this.video.videoList = response.data.return_video
              // this.video.videoListSpec = response.data.return_video_spec

              // this.activeType = type
              // this.activeItem = index

              // if(type == 1){
              //   this.showMaterialSingle = true;
              // } else {
              //   this.showMaterial = true;
              // }

              // this.showVideoWindows = true
            }
          });
    },
    materialUpdate(){
    //  console.log('materialUpdate');
      this.showVideoLoading = false;

      this.image.imageList = null;
      this.image.imageListSpec = null;
      this.image.imageListName = null;
      this.image.imageListTitle = null;
      this.video.videoList = null;
      this.video.videoListSpec = null;
      this.video.videoListName = null;
      this.video.videoListTitle = null;

      axios
        .post('https://www.autoturn.net/api/customize/campaign/campaign_form_adimages.php', Qs.stringify({
          s_code: this.$route.params.id,
          adaccount_id: this.$route.params.adaccount_id,
          type: 'update'
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            this.imageAfter = response.data.after_image

            this.image.imageList = response.data.return_image
            this.image.imageListSpec = response.data.return_image_spec
            this.image.imageListName = response.data.return_image_name
            this.image.imageListTitle = response.data.return_image_title

            // if(type == 1){
            //   this.showMaterialSingle = true;
            // } else {
            //   this.showMaterial = true;
            // }

            // this.showVideoWindows = true

            // this.showVideoLoading = true;

            axios
              .post('https://www.autoturn.net/api/customize/campaign/campaign_form_advideos.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                type: 'update'
              }))
              .then((response) => {
                // if(response.data.status == 'success'){
                  this.videoAfter = response.data.after_video

                  this.video.videoList = response.data.return_video
                  this.video.videoListSpec = response.data.return_video_spec
                  this.video.videoListName = response.data.return_video_name
                  this.video.videoListTitle = response.data.return_video_title

                  // if(type == 1){
                  //   this.showMaterialSingle = true;
                  // } else {
                  //   this.showMaterial = true;
                  // }

                  // this.showVideoWindows = true

                  this.showVideoLoading = true;
                // }
              });
          } else {
            axios
              .post('https://www.autoturn.net/api/customize/campaign/campaign_form_advideos.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                type: 'update'
              }))
              .then((response) => {
                // if(response.data.status == 'success'){
                  this.videoAfter = response.data.after_video

                  this.video.videoList = response.data.return_video
                  this.video.videoListSpec = response.data.return_video_spec
                  this.video.videoListName = response.data.return_video_name
                  this.video.videoListTitle = response.data.return_video_title

                  // if(type == 1){
                  //   this.showMaterialSingle = true;
                  // } else {
                  //   this.showMaterial = true;
                  // }

                  // this.showVideoWindows = true

                  this.showVideoLoading = true;
                // }
              });
          }
        });
    }
  },
  computed: {
    moreWording() {
      return this.moreInput ? "隱藏" : "顯示";
    },
    showAddModal: {
      get: function () {
        return this.showAdd
      },
      set: function (value) {
        this.$emit('update:showAdd', value)
      }
    },
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    },
    viewDatalistData: {
      get: function () {
        return this.viewDatalist
      },
      set: function (value) {
        this.$emit('update:viewDatalistData', value)
      },
    },
    returnCampaignObjectiveData: {
      get: function () {
        return this.returnCampaignObjective
      },
      set: function (value) {
        this.$emit('update:returnCampaignObjectiveData', value)
      },
    },
    currentMessageId() {
      if(this.items && this.items[this.currentTab] && this.items[this.currentTab].message_sr_i) {
        return this.items[this.currentTab].message_sr_i + '_0';
      }
      return null;
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep(.tab) {
  .p-tabview .p-tabview-nav {
    display: none;
  }

  .p-tabview .p-tabview-panels {
    padding: 0px;
  }
}
</style>
